import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoBolletteStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }
    $scope.fornitore = {};

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    // <editor-fold desc='openWorkerModal'>
    $scope.openWorkerModal = (size) => {
      if ($scope.anagraficaIsNew) {
        $scope.saveAnagrafica();
      }

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');
      $scope.settings.fornitoreDenominazione = $scope.fornitore.anagrafica.full_name;
      $scope.settings.meseInizio = $scope.months[$scope.settings.meseInizioId];
      $scope.settings.meseFine = $scope.months[$scope.settings.meseFineId];

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerBolletteVersamentoModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: $scope.settings
        }
      });
    };
    // </editor-fold>

    $scope.saveAnagrafica = () => {
      let anagrafica = {
        'email_pec': '',
        'emails': [],
        'company_name': $scope.fornitore.anagrafica.full_name,
        'piva': $scope.settings.fornitorePIVA,
        'fiscal_code': ''
      };

      ArchiSmallServices.insertAnagrafica(anagrafica)
        .then((response) => {
          // ??
        }, (error) => {
          if (error.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', 'Anagrafica già esistente');
          }
        });
    };

    $rootScope.formsubmitted = false;

    // <editor-fold desc='setConservazioneSettings'>
    $scope.setConservazioneSettings = () => {
      $scope.settings.fornitoreDenominazione = $scope.fornitore.anagrafica;
      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response) => {
          // ?
        }, (error) => {
          $rootScope.alert('error', error);
        });

    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.fornitore.anagrafica = $scope.settings.fornitoreDenominazione;

          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
      //                    $state.go('home.conservazione-carica-documento-' + $scope.classeDocumentale + '-step2');
    }

    $scope.dpOpened = {
      dataDocumento: false,
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.autoOpen = ($event, opened) => {
      /* tslint:disable:no-string-literal */
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };
    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item) => {
      if (item !== undefined && typeof item === 'object') {

        if (item.piva === undefined) {
          $scope.settings.fornitorePIVA = '';
          $scope.anagraficaIsNew = true;
        } else {
          $scope.settings.fornitorePIVA = item.piva;
          $scope.anagraficaIsNew = false;
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);

      $scope.fornitore.anagrafica = '';
      $scope.settings.fornitorePIVA = '';
      $scope.anagraficaIsNew = false;
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

  }

}

export const ConservazioneCaricaDocumentoBolletteStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-bollette-step2.html'),
  controller: ConservazioneCaricaDocumentoBolletteStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-bollette-step2/conservazione-carica-documento-bollette-step2.ts